import { Key } from './shortcut.model';

const KEYS_MAP: Record<Key, string> = {
  arrowDown: 'ArrowDown',
  arrowLeft: 'ArrowLeft',
  arrowRight: 'ArrowRight',
  arrowUp: 'ArrowUp',
  back: 'Back',
  backspace: 'Backspace',
  delete: 'Delete',
  enter: 'Enter',
  escape: 'Escape',
  space: 'Space',
  a: 'KeyA',
  c: 'KeyC',
  d: 'KeyD',
  f: 'KeyF',
  n: 'KeyN',
  s: 'KeyS',
  v: 'KeyV',
  x: 'KeyX',
  y: 'KeyY',
  z: 'KeyZ',
  // 0: 'Digit0', // just for example
};

export function getCode(key: Key): string {
  return KEYS_MAP[key];
}
